// default
export const ALARM = 'alarm';
export const ALARM_SLICE_NAME = `${ALARM}Slice`;

// action
const GET_ALARMS = `${ALARM}/getAlarmList`;
const GET_UNREAD_ALARM_COUNT = `${ALARM}/getAlarmCount`;
const POST_ALARM_READED = `${ALARM}/postAlarmReaded`;
const CREATE_ENV_ALARM = `${ALARM}/createEnvAlarm`;

// actions
export const actions = {
  GET_ALARMS,
  GET_UNREAD_ALARM_COUNT,
  POST_ALARM_READED,
  CREATE_ENV_ALARM
};
